import { KineticLines } from "../components/KineticLines";
import { Reveal } from "../components/Reveal";
import { EventRow } from "../components/EventRow";
import { WhatsAppCTA } from "../components/WhatsAppCTA";
import { useSiteContent } from "../hooks/useSiteContent";
import { IMAGES } from "../data/content";

export default function Eventi() {
  const { events } = useSiteContent();

  return (
    <section data-testid="eventi-page" className="mx-auto max-w-[1400px] px-5 pb-24 pt-28 md:px-10 md:pt-40 md:pb-32">
      <Reveal y={12}>
        <div className="mb-8 flex items-center gap-3">
          <span className="h-2.5 w-2.5 bg-orange" aria-hidden="true" />
          <span className="font-oswald text-xs uppercase tracking-[0.3em] text-navy md:text-sm">Eventi e notizie</span>
        </div>
      </Reveal>
      <KineticLines
        lines={["In piazza,", <span key="s" className="text-orange">non sui social.</span>]}
        className="font-oswald text-[clamp(2.8rem,8vw,7rem)] font-semibold uppercase leading-[0.95] tracking-tight"
      />
      <Reveal delay={0.4} className="mt-8 max-w-xl">
        <p className="text-base leading-relaxed opacity-80">
          Assemblee, banchetti, giornate di cura del territorio: i nostri appuntamenti sono sempre aperti a tutti.
          Vieni, ascolta, proponi.
        </p>
      </Reveal>

      {events.length > 0 ? (
        <div data-testid="events-list" className="mt-16 border-t border-ink">
          {events.map((e, i) => (
            <EventRow key={i} event={e} index={i} />
          ))}
        </div>
      ) : (
        <Reveal className="mt-16">
          <div data-testid="events-empty" className="grid items-center gap-0 border border-ink lg:grid-cols-2">
            <div className="p-8 md:p-12">
              <span className="block h-2.5 w-2.5 bg-orange" aria-hidden="true" />
              <h2 className="mt-6 font-oswald text-2xl font-semibold uppercase leading-tight tracking-tight md:text-4xl">
                Il calendario è in <span className="text-orange">preparazione.</span>
              </h2>
              <p className="mt-4 max-w-md text-sm leading-relaxed opacity-80">
                Stiamo organizzando le prime iniziative sul territorio. Appena le date saranno definite,
                le troverai qui — intanto scrivici su WhatsApp per non perdertele.
              </p>
              <div className="mt-8">
                <WhatsAppCTA
                  testId="events-page-empty-whatsapp-button"
                  label="Avvisami"
                  message="Ciao! Avvisatemi quando saranno in programma i primi eventi di Progetto Città."
                />
              </div>
            </div>
            <div className="h-full overflow-hidden border-t border-ink lg:border-l lg:border-t-0">
              <img
                src={IMAGES.porto}
                alt="Il bastione sul mare di Trapani"
                loading="lazy"
                className="h-full max-h-[420px] w-full object-cover"
              />
            </div>
          </div>
        </Reveal>
      )}

      <Reveal className="mt-16">
        <div data-testid="propose-event-card" className="flex flex-col items-start gap-8 border border-ink bg-navy p-8 text-bone md:flex-row md:items-center md:justify-between md:p-12">
          <div>
            <h2 className="font-oswald text-2xl font-semibold uppercase tracking-tight md:text-4xl">
              Vuoi proporre un'iniziativa?
            </h2>
            <p className="mt-3 max-w-lg text-sm leading-relaxed text-bone/75">
              Una pulizia di quartiere, un incontro su un tema che ti sta a cuore, una raccolta solidale:
              scrivici e la costruiamo insieme.
            </p>
          </div>
          <WhatsAppCTA
            testId="propose-event-whatsapp-button"
            label="Proponi un evento"
            message="Ciao! Vorrei proporre un'iniziativa per Progetto Città."
          />
        </div>
      </Reveal>
    </section>
  );
}
